import React, { Component } from "react";
import classnames from "classnames";
import "react-responsive-modal/styles.css";
import Form from "react-bootstrap/Form";
//import Row from "react-bootstrap/Row";
import { Modal } from "react-responsive-modal";
import {
  // PopupActionButton,
  PopupInsideButton,
} from "../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { NewInputText } from "../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { ReusableOnboardingButton } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { DropDownButton } from "../../../../../reusableComponents/dropDownButtonReusable/DropDownButton";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../../store/actions/errorActions";
import isEmpty from "../../../../../../store/validation/is-Empty";
import { sa_get_update_whole_vendor_onboarding } from "../../../../../../store/actions/SuperAdminVendorDashboardAction/SuperAdminGetVendorOnboardingDetails";

export class AdminSetVendorWaitTime extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      min_wait_time: "",
      max_wait_time: "",
      select_wait_time: "",
      errors: {},
      hasSetWaitTimeProps: false,
      loader: false,
    };
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      nextProps.onboarding._id &&
      !isEmpty(nextProps.onboarding.seatingWaitingTime)
    ) {
      if (
        !isEmpty(nextProps.onboarding.seatingWaitingTime) &&
        !nextState.hasSetWaitTimeProps
      ) {
        return {
          select_wait_time: !isEmpty(nextProps.onboarding.seatingWaitingTime)
            ? nextProps.onboarding.seatingWaitingTime
            : "00-00",
          hasSetWaitTimeProps: true,
        };
      }
    }
    return null;
  }

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onChangeWalkinWaitlist = (e) => {
    let { value, min, max, maxLength } = e.target;
    value =
      Math.max(Number(min), Math.min(Number(max), Number(value))) ||
      value.slice(0, maxLength);
    this.setState({
      [e.target.name]: value,
      errors: {},
    });
  };

  /***************************
   * @DESC Big Button Handler
   ***************************/
  bigButtonHandler = (e, type) => {
    e.preventDefault();
    const formData = {
      id: this.props.onboarding._id,
      vendor_id: this.props.onboarding.vendor_id,
      seatingWaitingTime: type,
    };
    this.props.sa_get_update_whole_vendor_onboarding(formData);
    this.setState({
      select_wait_time: type,
      open: false,
    });
  };

  /******************************
   * @DESC - ON SUBMIT HANDLER
   *****************************/
  onSubmitHandler = (e) => {
    e.preventDefault();
    const min_wait_time = this.state.min_wait_time;
    const max_wait_time = this.state.max_wait_time;
    const formData = {
      id: this.props.onboarding._id,
      vendor_id: this.props.onboarding.vendor_id,
      seatingWaitingTime: min_wait_time + "-" + max_wait_time,
    };
    this.props.sa_get_update_whole_vendor_onboarding(formData);
    this.setState({
      open: false,
    });
  };

  render() {
    const { open, errors, select_wait_time } = this.state;
    return (
      <div>
        <DropDownButton
          dropDownCss="main-dropdown-section d-flex align-items-center"
          headingText="Set Wait time"
          divClass="insidedropdown-div-other"
          insideText={this.state.select_wait_time}
          displayDropDown={true}
          onClick={this.onOpenModal}
        />
        <Modal
          open={open}
          onClose={this.onCloseModal}
          center
          classNames={{
            overlay: "customOverlay-request-accept-cancelled",
            modal: "small-popup max-433",
            closeButton: "customCloseButton",
            animationIn: "customEnterAnimation",
            animationOut: "customLeaveAnimation",
          }}
          animationDuration={1000}
        >
          <div className="reusable-popup-header-newstyle">
            <h4 className="c-black font_24_b">Set Wait Time</h4>
          </div>
          <div className="">
            <Form>
              <div className="mt-2 mb-3">
                <div className="row justify-content-between align-items-center">
                  <div className="col-6">
                    <NewInputText
                      inputType="number"
                      labelText="Min Wait"
                      extraClass="mb-0 w-100"
                      inputType="number"
                      min="00"
                      max="60"
                      maxLength="2"
                      name="min_wait_time"
                      onChange={this.onChangeWalkinWaitlist}
                      value={this.state.min_wait_time}
                      required="required"
                    />
                    <div className="f9-400">Minimum wait in mins</div>
                  </div>
                  <div className="col-6">
                    <NewInputText
                      inputType="number"
                      labelText="Max Wait"
                      extraClass="mb-0 w-100"
                      inputType="number"
                      min="00"
                      max="60"
                      maxLength="2"
                      name="max_wait_time"
                      onChange={this.onChangeWalkinWaitlist}
                      value={this.state.max_wait_time}
                      required="required"
                    />
                    <div className="f9-400">Maximum wait in mins</div>
                  </div>
                </div>
                <hr />
                <div>
                  <div className="f16-500 c_black mb-2">
                    Select one relevant option from below
                  </div>
                  <div className="f12-400 c_black mb-4">
                    Highest value from below will be sent as wait time
                  </div>
                </div>
                <div className="row">
                  <div className="col-6 col-md-4 mb-4">
                    <PopupInsideButton
                      buttonClass={
                        select_wait_time === "00-00"
                          ? "status-selected-button-box f16-500 sts_sld_btn_box_a"
                          : "status-selected-button-box f16-500"
                      }
                      buttonText="00 - 00 &nbsp; Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "00-00")}
                    />
                  </div>
                  <div className="col-6 col-md-4 mb-4">
                    <PopupInsideButton
                      buttonClass={
                        select_wait_time === "00-05"
                          ? "status-selected-button-box f16-500 sts_sld_btn_box_a"
                          : "status-selected-button-box f16-500"
                      }
                      buttonText="00 - 05 &nbsp; Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "00-05")}
                    />
                  </div>
                  <div className="col-6 col-md-4 mb-4">
                    <PopupInsideButton
                      buttonClass={
                        select_wait_time === "05-10"
                          ? "status-selected-button-box f16-500 sts_sld_btn_box_a"
                          : "status-selected-button-box f16-500"
                      }
                      buttonText="05 - 10 &nbsp; Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "05-10")}
                    />
                  </div>
                  <div className="col-6 col-md-4 mb-4">
                    <PopupInsideButton
                      buttonClass={
                        select_wait_time === "10-15"
                          ? "status-selected-button-box f16-500 sts_sld_btn_box_a"
                          : "status-selected-button-box f16-500"
                      }
                      buttonText="10 - 15 &nbsp; Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "10-15")}
                    />
                  </div>
                  <div className="col-6 col-md-4 mb-4">
                    <PopupInsideButton
                      buttonClass={
                        select_wait_time === "15-20"
                          ? "status-selected-button-box f16-500 sts_sld_btn_box_a"
                          : "status-selected-button-box f16-500"
                      }
                      buttonText="15 - 20 &nbsp; Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "15-20")}
                    />
                  </div>
                  <div className="col-6 col-md-4 mb-4">
                    <PopupInsideButton
                      buttonClass={
                        select_wait_time === "20-25"
                          ? "status-selected-button-box f16-500 sts_sld_btn_box_a"
                          : "status-selected-button-box f16-500"
                      }
                      buttonText="20 - 25 &nbsp; Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "20-25")}
                    />
                  </div>
                  <div className="col-6 col-md-4 mb-4">
                    <PopupInsideButton
                      buttonClass={
                        select_wait_time === "25-30"
                          ? "status-selected-button-box f16-500 sts_sld_btn_box_a"
                          : "status-selected-button-box f16-500"
                      }
                      buttonText="25 - 30 &nbsp; Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "25-30")}
                    />
                  </div>
                  <div className="col-6 col-md-4 mb-4">
                    <PopupInsideButton
                      buttonClass={
                        select_wait_time === "30-40"
                          ? "status-selected-button-box f16-500 sts_sld_btn_box_a"
                          : "status-selected-button-box f16-500"
                      }
                      buttonText="30 - 40 &nbsp; Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "30-40")}
                    />
                  </div>
                  <div className="col-6 col-md-4 mb-4">
                    <PopupInsideButton
                      buttonClass={
                        select_wait_time === "40-45"
                          ? "status-selected-button-box f16-500 sts_sld_btn_box_a"
                          : "status-selected-button-box f16-500"
                      }
                      buttonText="40 - 45 &nbsp; Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "40-45")}
                    />
                  </div>
                  <div className="col-6 col-md-4 mb-4">
                    <PopupInsideButton
                      buttonClass={
                        select_wait_time === "45-50"
                          ? "status-selected-button-box f16-500 sts_sld_btn_box_a"
                          : "status-selected-button-box f16-500"
                      }
                      buttonText="45 - 50 &nbsp; Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "45-50")}
                    />
                  </div>
                  <div className="col-6 col-md-4 mb-4">
                    <PopupInsideButton
                      buttonClass={
                        select_wait_time === "50-55"
                          ? "status-selected-button-box f16-500 sts_sld_btn_box_a"
                          : "status-selected-button-box f16-500"
                      }
                      buttonText="50 - 55 Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "50-55")}
                    />
                  </div>
                  <div className="col-6 col-md-4 mb-4">
                    <PopupInsideButton
                      buttonClass={
                        select_wait_time === "55-60"
                          ? "status-selected-button-box f16-500 sts_sld_btn_box_a"
                          : "status-selected-button-box f16-500"
                      }
                      buttonText="55 - 60 Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "55-60")}
                    />
                  </div>
                </div>
              </div>
              <div className="mt-5 d-flex">
                <ReusableOnboardingButton
                  buttonTitle="Cancel Button"
                  buttonClass={"btn-lg btn btn-outline-secondary mr-3"}
                  buttonText="Cancel"
                  onClick={this.onCloseModal}
                  buttonType="button"
                />
                <ReusableOnboardingButton
                  buttonTitle="Confirm Button"
                  buttonClass="btn-lg btn btn-danger"
                  buttonText="Confirm"
                  onClick={this.onSubmitHandler}
                  buttonType="button"
                />
              </div>
            </Form>
          </div>
        </Modal>
      </div>
    );
  }
}

AdminSetVendorWaitTime.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  sa_get_update_whole_vendor_onboarding: PropTypes.func.isRequired,
  onboarding: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.adminWholeVendorOnboarding.admin_vendor_onboarding_details,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  sa_get_update_whole_vendor_onboarding,
})(withRouter(AdminSetVendorWaitTime));
